import { DreamBlock, DreamValue } from '@typedream/core';
import { ComponentType } from 'react';
import {
  AnyObject, PlatePlugin, TRenderElementProps,
} from '@udecode/plate-core';
import { createTElementPluginFactory } from '../../plate';
import { ELEMENT_COLLECTION } from '../../pluginKeys';
import { withDropTarget } from '../../plugins/dnd';
import CollectionElementWrapper from './components/CollectionElement';
import { createCollectionItemPlugin } from './createCollectionItemPlugin';
import { CollectionItemPluginOptions, CollectionPluginOptions, ICollectionData } from './types';
import { withCollection } from './withCollection';
import { BaseDreamEditor } from '../../types';
import { createRichTextContentPlugin } from './createRichTextPlugin';

export const createCollectionPlugin = createTElementPluginFactory<CollectionPluginOptions>({
  key: ELEMENT_COLLECTION,
  component: withDropTarget(CollectionElementWrapper as ComponentType<TRenderElementProps>),
  options: {
    isDreamBlock: true,
    isSelectable: true,
    isResizable: true,
    isDraggable: true,
    isDroppable: true,
    meta: {
      img: '/canvas/images/collections.png',
      title: 'Collection',
      subtitle: 'A list of items from a data source',
      keywords: ['collection', 'list', 'cms', 'blog', 'items'],
    },
    format: {
      formatType: 'block',
      blurAfterSet: true,
      insertNode: {
        type: ELEMENT_COLLECTION,
        children: [
          {
            text: '',
          },
        ],
      } as DreamBlock,
      turnInto: [],
      focusableWhenEmpty: false,
      validProperties: [
        'collection_data_id',
        'collection_template',
        'width',
        'width_max',
        'mobile_hide',
        'desktop_hide',
      ],
    },
    collectionData: {} as ICollectionData,
    setsidebarTemplateOpen: () => {
      throw Error('You have to override this');
    },
    sidebarTemplateOpen: false,
    setsettingsOpen: () => {
      throw Error('You have to override this');
    },
    settingsOpen: false,
    templatePath: null,
    settemplatePath: () => {
      throw Error('You have to override this');
    },
    getVisitorFilterList: () => {
      throw Error('You have to override this');
    },
    getIsTableConnected: () => {
      throw Error('You have to override this');
    },
    visitorFilterList: [],
    showSchema: false,
    getItemPageDataID: () => {
      throw Error('You have to override this');
    },
    getNextData: () => {
      throw Error('You have to override this');
    },
    nextDataLoading: false,
    selectedTemplate: null,
    selectedCategory: null,
    hovered: null,
    space: null,
    loadingPage: false,
    collectionSynced: false,
  },
  withOverrides: withCollection,
  plugins: [
    createCollectionItemPlugin<
    CollectionItemPluginOptions>() as unknown as PlatePlugin<
    AnyObject, DreamValue, BaseDreamEditor>, createRichTextContentPlugin()],
});
